import { BaseEditor, Editor } from 'slate';
import { ReactEditor } from 'slate-react';
import { MarkFormatType } from './textEditor.constant';

export const isMarkActive = (editor: BaseEditor & ReactEditor, format: MarkFormatType) => {
  const marks = Editor.marks(editor);
  return marks ? !!(marks as any)[format] : false;
};
